<template>
	<div class="app">
		<!-- <dv-border-box-1>dv-border-box-1</dv-border-box-1> -->
		<div class="home-mode">
			<div class="home-mode-view" @click="goPages('1')">
				<dv-border-box-12 backgroundColor="#08BDB4">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/dnzl1.png" alt="" />
						</div>
						<p class="home-mode-view-p">智慧用电管理</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('1')" v-if="SystemList.indexOf('1') >= 0">解绑</Button>
				</div>
			</div>

			<div class="home-mode-view" @click="goPages('2')">
				<dv-border-box-12 backgroundColor="#1B96D1">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/aqyd1.png" alt="" />
						</div>
						<p class="home-mode-view-p">智慧消防综合执法社区小区管理</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('2')" v-if="SystemList.indexOf('2') >= 0">解绑</Button>
				</div>
			</div>

			<div class="home-mode-view" @click="goPages('3')">
				<dv-border-box-12 backgroundColor="#8D57C4">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/yyjc1.png" alt="" />
						</div>
						<p class="home-mode-view-p">燃气公司充气站中转运输管理</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('3')" v-if="SystemList.indexOf('3') >= 0">解绑</Button>
				</div>
			</div>

			<div class="home-mode-view" @click="goPages('4')">
				<dv-border-box-12 backgroundColor="#C457A2">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/sjzxdh1.png" alt="" />
						</div>
						<p class="home-mode-view-p">接入城市大脑数据中心</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('4')" v-if="SystemList.indexOf('4') >= 0">解绑</Button>
				</div>
			</div>
			
			<div class="home-mode-view" @click="goPages('5')">
				<dv-border-box-12 backgroundColor="#B5C354">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/hby1.png" alt="" />
						</div>
						<p class="home-mode-view-p">运行状态智能诊断系统</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('5')" v-if="SystemList.indexOf('5') >= 0">解绑</Button>
				</div>
			</div>
			
			<div class="home-mode-view" @click="goPages('6')">
				<dv-border-box-12 backgroundColor="#F28500">
					<div class="home-mode-view-ms">
						<div class="home-mode-view-img">
							<img src="../../../assets/home/water1.png" alt="" />
						</div>
						<p class="home-mode-view-p">水电表预付费管理平台</p>
					</div>
				</dv-border-box-12>
				<div class="home-mode-view-down">
					<Button size="small" type="error" @click.stop="down('6')" v-if="SystemList.indexOf('6') >= 0">解绑</Button>
				</div>
			</div>

			<Spin size="large" fix v-if="spinShow"></Spin>
		</div>

		<!-- 新增 -->
		<HomeModel :isShow="add_model" :systemName="systemNameState" :details="details" @on-change="addChange"></HomeModel>

	</div>
</template>

<script>
	import {
		GetSysUserSystemModels,
		UnBindSystemAccount,
		BindSystemAccount,
		LoginSso,
	} from "@/api/url_api.js";
	import md5 from "@/api/md5.js";
	import Cookies from "js-cookie";
	import HomeModel from "../home_model.vue";
	export default {
		components: {
			HomeModel,
		},
		data() {
			return {
				SysUserSystemModels: [],
				spinShow: false,
				SystemItem: '',
				SystemList: [],

				add_model: false,
				details: {},
				systemNameState: '',

			};
		},

		computed: {
			refreshState() {
				let _this = this;
				return _this.$store.getters.getRefreshState;
			},
		},

		watch: {
			refreshState(value) {
				if (value) {
					this.getSysUserSystemModels();
					this.$store.dispatch("setRefreshState", false);
				}
			},
		},

		mounted() {
			let _this = this;
			_this.getSysUserSystemModels();
		},

		methods: {
			getSysUserSystemModels() {
				let _this = this;
				GetSysUserSystemModels(`?pageIndex=1&pageSize=10&status=A`)
					.then((res) => {
						if (res.Success) {
							_this.SysUserSystemModels = res.Data;
							_this.SystemList = res.Data.map(item => item.SystemName);
							console.log("12",res.Data);
							console.log("123",_this.SystemList);
						} else {
							_this.$Message["error"]({
								background: true,
								content: res.Message,
							});
						}
					})
					.catch((err) => {
						if (err.data.Code == -9 || err.data.Message == '缺少token' || err.data.Message == '未找到身份认证信息，请重新登录') {
							_this.$router.push({
								name: "login",
							});
						} else {
							_this.$Message["error"]({
								background: true,
								content: err.data.Message,
							});
						}
					});
			},
			// 解绑系统
			down(SystemName) {
				let _this = this;
				let SystemItem = _this.SysUserSystemModels.find(item => {
					return item.SystemName === SystemName;
				})
				_this.$Modal.confirm({
					title: "提示",
					content: `<p>是否解绑${
          SystemName == "2"
          ? "智慧消防综合执法社区小区管理"
          : SystemName == "1"
          ? "智慧用电管理"
					: SystemName == "5"
					? "运行状态智能诊断系统"
					: SystemName == "6"
					? "水电表预付费管理平台"
          : "燃气公司充气站中转运输管理"
        }</p>`,
					onOk: () => {
						UnBindSystemAccount(`?sysUserSystem_Id=${SystemItem.Id}`)
							.then((res) => {
								if (res.Success) {
									_this.$Message["success"]({
										background: true,
										content: res.Message,
									});
									_this.getSysUserSystemModels();
								} else {
									_this.$Message["error"]({
										background: true,
										content: res.Message,
									});
								}
							})
							.catch((err) => {
								console.log(err);
							});
					},
					onCancel: () => {},
				});
			},

			// 前往系统
			goPages(SystemName) {
				let _this = this;

				if (SystemName == '4') {	
					
					_this.LoginSsoLogin();
					
					return;
				}

				_this.SystemItem = _this.SysUserSystemModels.find(item => {
					return item.SystemName === SystemName;
				})

				if (_this.SystemItem) {
					if (SystemName == '1') {
						_this.spinShow = true;
						LoginSso(`?systemName=${SystemName}`)
							.then((res) => {
								_this.spinShow = false;
								let data = JSON.parse(res);
								if (data.Success) {
									
									let ros_data = JSON.parse(data.Data);

									let tempwindow = window.open('_blank'); // 先打开页面
									tempwindow.location = ros_data.url; // 后更改页面地址

								} else {
									_this.$Message["error"]({
										background: true,
										content: data.Message,
									});
								}
							})
							.catch((err) => {
								_this.spinShow = false;
								if (err.data.Code == -9 || err.data.Message == '缺少token' || err.data.Message == '未找到身份认证信息，请重新登录') {
									_this.$router.push({
										name: "login",
									});
								} else {
									_this.$Message["error"]({
										background: true,
										content: err.data.Message,
									});
								}
							});
					} else if (SystemName == '2') {
						let tempwindow = window.open('_blank'); // 先打开页面
						tempwindow.location = `http://home.hxpwr.com/#/intermediate?form=Sso&ssk=ky${Cookies.get('ssk')}`; // 后更改页面地址
					} else if (SystemName == '3') {
						let tempwindow = window.open('_blank'); // 先打开页面
						tempwindow.location = `http://gps.hxpwr.com/#/intermediate?form=Sso&ssk=ky${Cookies.get('ssk')}`; // 后更改页面地址
					} else if (SystemName == '6') {
						let username = _this.SystemItem.SystemLoginCode;
						let password = _this.SystemItem.SystemPassword;
						password = md5(password, 32);
						let tempwindow = window.open('_blank'); // 先打开页面
						tempwindow.location = `https://www.zt-meter.cn/#/sso?username=${username}&password=${password}`; // 后更改页面地址
					} else if (SystemName == '5') {
						_this.spinShow = true;
						LoginSso(`?systemName=${SystemName}`)
							.then((res) => {
								_this.spinShow = false;
								let tempwindow = window.open('_blank'); // 先打开页面
								tempwindow.location = res; // 后更改页面地址
							})
							.catch((err) => {
								_this.spinShow = false;
								if (err.data.Code == -9 || err.data.Message == '缺少token' || err.data.Message == '未找到身份认证信息，请重新登录') {
									_this.$router.push({
										name: "login",
									});
								} else {
									_this.$Message["error"]({
										background: true,
										content: err.data.Message,
									});
								}
							});
					}
				} else {
					_this.systemNameState = SystemName;
					_this.add_model = true;
				}

			},
			
			async LoginSsoLogin() {
				let _this = this;
				
				_this.spinShow = true;
				
				// 智慧用电管理登录
				const x = await _this.LoginSso1();
				
				// 智慧小区管理登录
				const y = await _this.LoginSso2();
				
				_this.spinShow = false;
				
				if (x && y) {
					_this.$router.push({
						name: "service_center",
					});
				} else {
					
					_this.$Message["error"]({
						background: true,
						content: '系统未绑定账号，请进行绑定',
					});
					
					// 清除
					Cookies.set('ros_CompanyCode', '');
					Cookies.set('ros_DepartmentCode', '');
					Cookies.set('ros_GroupCode', '');
					Cookies.set('ros_isAdmin', '');
					
					// 清除储存后台返回位置
					Cookies.set('yhjCityName', '');
										
					// 清除token
					Cookies.set('yhjToken', '');
										
					// 清除集团部门编号
					Cookies.set('yhjAdminData', {});
										
					// 清除登录名
					Cookies.set('yhjUserLogin', '');
					
				}				
				
			},
			
			// 智慧用电管理登录
			LoginSso1() {
				let _this = this;
				const loginSso_1 = new Promise((resolve, reject) => {
					LoginSso(`?systemName=1`)
						.then((res) => {
							let data = JSON.parse(res);
							if (data.Success) {
								resolve(true)
								let ros_data = JSON.parse(data.Data);
								
								// 保存登录信息
								Cookies.set('ros_CompanyCode', ros_data.CompanyCode);
								Cookies.set('ros_DepartmentCode', ros_data.DepartmentCode);
								Cookies.set('ros_GroupCode', ros_data.GroupCode);
								Cookies.set('ros_isAdmin', ros_data.isAdmin);
					
							} else {
								resolve(false)
							}
						})
				})
				return loginSso_1;
				
			},

			// 智慧小区管理登录
			LoginSso2() {
				let _this = this;
				const loginSso_2 = new Promise((resolve, reject) => {
					LoginSso(`?systemName=2`)
						.then((res) => {
							let data = JSON.parse(res);
							if (data.Success) {
								resolve(true)
								// 储存后台返回位置
								Cookies.set('yhjCityName', data.Data.AddressName);
					
								// 保存token
								Cookies.set('yhjToken', data.Data.token_type + ' ' + data.Data.access_token);
					
								// 保存集团部门编号
								Cookies.set('yhjAdminData', {
									GroupCode: data.Data.GroupCode,
									CompanyCode: data.Data.CompanyCode,
									DepartmentCode: data.Data.DepartmentCode,
									IsAdmin: data.Data.IsAdmin,
									TittleName: data.Data.TittleName,
									TittleNameEN: data.Data.TittleNameEN,
									ImageUrl: data.Data.ImageUrl
								});
					
								// 保存登录名
								Cookies.set('yhjUserLogin', data.Data.UserInfo.UserLogin);
					
							} else {
								resolve(false)
							}
						})
				})
				return loginSso_2;			
				
			},

			addChange(stateMsg, value) {
				let _this = this;
				_this.add_model = stateMsg;

				if (value) {
					value.SystemName = _this.systemNameState;
					BindSystemAccount(value)
						.then((res) => {
							if (res.Success) {
								_this.$Message["success"]({
									background: true,
									content: res.Message,
								});
								_this.$store.dispatch("setRefreshState", true);
							} else {
								_this.$Message["error"]({
									background: true,
									content: res.Message,
								});
							}
						})
						.catch((err) => {
							_this.$Message["error"]({
								background: true,
								content: err.response.Message,
							});
						});
				}
			},

		},
	};
</script>

<style scoped>
	.app {
		height: 100%;
	}

	.home-mode {
		width: 100%;
		height: 100%;
		padding-left: 6%;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		justify-content: flex-start;
		overflow: hidden;
	}

	.home-mode-view {
		width: 20%;
		height: 20%;
		margin: 1vw;
		position: relative;
		top: 30%;
		flex-wrap: wrap;
		transform: translateY(-30%);
	}

	.home-mode-view-ms {
		width: 100%;
		height: 100%;
		overflow: hidden;
		transition-duration: 0.5s;
	}

	.home-mode-view-ms:hover {
		transform: scale(1.2);
		cursor: pointer;
	}

	.home-mode-view-img {
		width: 3.5vw;
		height: 3.5vw;
		overflow: hidden;
		margin: 0 auto;
		position: relative;
		top: 30%;
		transform: translateY(-30%);
	}

	.home-mode-view-img img {
		width: 100%;
		height: 100%;
	}

	.home-mode-view-p {
		width: 100%;
		text-align: center;
		font-size: 0.9vw;
		color: white;
		font-weight: bold;
		margin-top: 1.75vw;
	}

	.home-mode-view-down {
		width: 2.5vw;
		height: 1.5vw;
		position: absolute;
		top: 0.75vw;
		right: 0.5vw;
		overflow: hidden;
		display: none;
		cursor: pointer;
	}

	.home-mode-view-down>>>.ivu-btn-small {
		height: 1.2vw;
		padding: 0.1vw 0.35vw;
		font-size: 0.7vw;
		border-radius: 0.15vw;
	}

	.home-mode-view-down img {
		width: 0.8vw;
		height: 0.8vw;
		margin: 0.6vw;
	}

	.home-mode-view:hover .home-mode-view-down {
		display: block;
	}

	.app>>>.ivu-spin-fix {
		background-color: rgba(81, 90, 110, 0.3);
		z-index: 1000;
	}
</style>
